import './VenueHeader.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { useLocation } from 'react-router-dom';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as IconStar } from '../../resources/icons/star.svg';
import ShortlistBtn from '../atoms/ShortlistBtn/ShortlistBtn';
const VenueHeader = _ref => {
  let {
    fields,
    rendering,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const currentLang = get(sitecoreContext, 'language');
  // const pageSize = params.SearchCount ? parseInt(params.SearchCount) : 10;
  const dictionary = get(fields, 'data.dictionary');
  const {
    pathname
  } = useLocation();
  const {
    addToFavoriteAnalytics,
    removeFromFavoriteAnalytics
  } = get(fields, 'data', {});
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const title = get(fields, 'data.item.title.jss.value');
  const introText = get(fields, 'data.item.introText.jss.value');
  const category = get(fields, 'data.item.category.targetItem.title.jss.value');
  const hotelStarRating = parseInt(get(fields, 'data.item.hotelStarRating.targetItem.title.jss.value'));
  const venueID = get(fields, 'data.item.id');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const variables = BackgroundColorHex ? {
    '--venue-header-background-color': BackgroundColorHex,
    '--venue-header-background-active-color': ActiveColorHex,
    '--venue-header-color': ColorHex
  } : {
    '--venue-header-background-color': selectedPrimaryColor,
    '--venue-header-background-active-color': selectedPrimaryActiveColor,
    '--venue-header-color': getColorByTheme(selectedPrimaryColor)
  };
  React.useEffect(() => {
    if (canUseDOM) {
      var elem = document.querySelector('.header__pagination-dots');
      if (elem) {
        // @ts-ignore
        elem.style.marginBottom = '-28px';
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-header__carousel"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "media-header-general",
    rendering: rendering
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "venue-header__category"
  }, category), /*#__PURE__*/React.createElement("div", {
    className: "section-intro"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3 section__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "body-small section__desc"
  }, /*#__PURE__*/React.createElement("p", null, introText)), /*#__PURE__*/React.createElement(ShortlistBtn, {
    id: venueID,
    sitecoreContext: sitecoreContext,
    title: title,
    analytics: {
      add: addToFavoriteAnalytics,
      remove: removeFromFavoriteAnalytics
    },
    dynamicColor: BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor,
    dynamicColorActive: BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor,
    params: params
  })), /*#__PURE__*/React.createElement("div", {
    className: "venue-header__certification"
  }, hotelStarRating ? [/*#__PURE__*/React.createElement(IconStar, {
    key: "1"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "2"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "3"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "4"
  }), /*#__PURE__*/React.createElement(IconStar, {
    key: "5"
  })].slice(0, hotelStarRating) : null)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  })));
};
const commonStyles = "caedddc";
const ltrStyles = "l2ye0w0";
const rtlStyles = "r1cl73jy";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    style
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: style
  }, children);
};
export default VenueHeader;